module.exports = __webpack_public_path__ + "static/media/pucit.0d5c3eee.png";